var _linearGradient, _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconForbidden(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 64,
    viewBox: "0 0 64 64",
    width: 64,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    gradientUnits: "userSpaceOnUse",
    x1: 15,
    x2: 72.2574,
    y1: 11.5,
    y2: 62.2736
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff9f8a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#ff9793"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#ff8aa4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#ff80b1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#ff66d2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#f4f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#4900ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00005a"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m6.98123 31.891c.23057 2.6208-.0679 19.9216 18.86877 23.5525 5.9144 2.6528 23.021 2.2696 29.3763-8.9162 4.8842-8.5785 4.726-20.938-2.1019-27.0003-19.7378-28.07678-47.65239-5.339-46.14317 12.364z",
    fill: "#f1f1f1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m18.3512 20 25.7663 25.6488 1.6487-1.5757-25.7388-25.8393z",
    fill: "url(#a)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m31.9999 49.6c9.7202 0 17.6-7.8798 17.6-17.6s-7.8798-17.6-17.6-17.6-17.6 7.8798-17.6 17.6 7.8798 17.6 17.6 17.6z",
    stroke: "#00005a",
    strokeLinejoin: "round",
    strokeWidth: 2
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconForbidden);
export default __webpack_public_path__ + "static/media/icon-forbidden.2f284e7fc2aae714eb29333663632b22.svg";
export { ForwardRef as ReactComponent };